var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tech"},[_c('slide-show',{attrs:{"data":_vm.$root.banners,"ratio":'0.21'}}),_c('router-view',{staticClass:"fadeIn"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }